import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import styled from "styled-components"
import { ResourceFragment } from "../../api/generated"
import useClipboard from "../../clipboard/useClipboard"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import { canAdministrate } from "../../user/permissions"
import { RESOURCE_TYPE_COLLECTION } from "../constants"

const StyledContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
`

export function useResourceCopy(resource: ResourceFragment) {
  const pwContext = usePathwrightContext()
  const clipboard = useClipboard({ object_type: "resource" })

  // For now, don't show copy button for collections
  const enabled = resource.resource_type !== RESOURCE_TYPE_COLLECTION

  const clipData = {
    school_id: pwContext.school.id,
    user_is_admin_of_school: canAdministrate(pwContext),
    // Storing the entire resource so we can render a detailed paste component.
    resource
  }

  const clip = clipboard.getClip({ object_id: `${resource.id}` })
  const copied = !!clip

  const toggleCopy = () => {
    if (copied) {
      clipboard.clear()
    } else {
      clipboard.copy(
        {
          object_id: `${resource.id}`,
          object_label: resource.name
        },
        clipData
      )
    }
  }

  return {
    enabled,
    toggleCopy,
    copied
  }
}

const ResourceCopyControl = ({
  actionLabel = "Copy",
  resource
}: {
  actionLabel?: string
  resource: ResourceFragment
}) => {
  const { enabled, toggleCopy, copied } = useResourceCopy(resource)

  return enabled ? (
    <StyledContainer onClick={toggleCopy}>
      <Pathicon icon="copy" style={{ marginRight: "5px" }} />
      {copied ? "Copied" : actionLabel}
    </StyledContainer>
  ) : null
}

ResourceCopyControl.displayName = "ResourceCopyControl"

export default ResourceCopyControl
